import { __assign, __decorate, __extends, __rest } from "tslib";
import React from 'react';
import { observer } from 'mobx-react';
import { Utils } from '@singularsystems/neo-core';
import { FileContext } from './FileContext';
import ProgressBar from '../ProgressBar';
var FileUploadProgress = /** @class */ (function (_super) {
    __extends(FileUploadProgress, _super);
    function FileUploadProgress() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FileUploadProgress.prototype.render = function () {
        var _a = this.props, fileManager = _a.fileManager, type = _a.type, variant = _a.variant, domProps = __rest(_a, ["fileManager", "type", "variant"]);
        if (this.context.fileManager) {
            this.fileManager = this.context.fileManager;
        }
        else {
            if (!fileManager) {
                throw Error("FileUploadProgress must be in a FileContext, or have fileManager specified.");
            }
            this.fileManager = fileManager;
        }
        domProps.className = Utils.joinWithSpaces(domProps.className, "neo-file-progress-container");
        return (this.fileManager.isUploading &&
            React.createElement("div", __assign({}, domProps), this.fileManager.currentUploads.map(function (upload) { return (React.createElement("div", { key: upload.key, className: "neo-file-progress" },
                React.createElement("span", null, upload.toString()),
                React.createElement(ProgressBar, { progress: upload.uploadPercent, type: type, variant: variant }))); })));
    };
    FileUploadProgress.contextType = FileContext;
    FileUploadProgress = __decorate([
        observer
    ], FileUploadProgress);
    return FileUploadProgress;
}(React.Component));
export default FileUploadProgress;
